import DomainOptionFull from './components/DomainOptionFull';
import * as React from 'react';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { getUserConfiguration } from 'owa-session-store';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import store from './store/store';
var DomainOption = {
    key: 'domain',
    titleStringKey: 'options_premiumSubOption_PersonalEmail',
    searchTermsStringKey: 'options_premiumSubOption_PersonalEmail',
    hideTitleInFullOptions: true,
    fullOptionFormSettings: {
        render: function () { return React.createElement(DomainOptionFull, null); },
        isDirty: function () { return false; },
        onSave: null,
        onDiscard: null,
        hideSaveDiscard: function () { return true; },
    },
    isHidden: function () {
        return !isMailFeatureEnabled('auth-domainConnect') ||
            !isControlFeatureEnabled('auth-PremiumDashboardApril') ||
            !getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox ||
            !(store.isDomainCreated || store.isDomainRemoved);
    },
};
export default DomainOption;
//# sourceMappingURL=DomainOption.js.map